import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import FormattedCurrency from '@/components/Formatted/FormattedCurrency';
import { FormattedMessage } from 'react-intl';
import { getBuyNow } from '@/redux/modules/buyNow';
import { getCatalog } from '@/redux/modules/catalog';
import { getItem } from '@/redux/modules/item';
import ItemSaveContainer from '@/components/ItemSave/ItemSaveContainer';
import { modalTypes } from '@/enums';
import { openBuyNowModal } from '@/redux/modules/modal';
import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';
import styles from './BuyNowComponent.module.scss';

type Props = {
    itemId: number;
};
const BuyNowComponent = ({ itemId }: Props) => {
    const dispatch = useDispatch();
    const buyNow = useSelector((state) => getBuyNow(state, itemId));
    const item = useSelector((state) => getItem(state, itemId));
    const catalog = useSelector((state) => getCatalog(state, item.catalogId));

    const { price: buyNowPrice } = buyNow;
    const { currency } = catalog;
    const { highBidEstimate } = item;

    const showBuyNowModal = () => {
        dispatch(
            openBuyNowModal({
                itemId: itemId,
                modalType: modalTypes.BUY_NOW,
                offerPrice: buyNowPrice,
            })
        );
    };

    const openMakeOfferModal = () => {
        dispatch(openBuyNowModal({ itemId: itemId, modalType: modalTypes.MAKE_OFFER }));
    };

    return (
        <div className={styles['buy-now']}>
            <div className={styles.prices}>
                <div className={styles.buyNowPrice}>
                    <FormattedCurrency sourceCurrency={currency} value={buyNowPrice} />
                </div>
                <div className={styles.highBidEstimate}>
                    <FormattedCurrency noFraction sourceCurrency={currency} value={highBidEstimate} />
                </div>
            </div>
            <div className={styles.buttons}>
                <ShouldLogInContainer requireCompleteProfile requireLogin runFunction={showBuyNowModal}>
                    <Button primary>
                        <FormattedMessage id="buy_now" />
                    </Button>
                </ShouldLogInContainer>
                <ShouldLogInContainer requireCompleteProfile requireLogin runFunction={openMakeOfferModal}>
                    <Button secondary>
                        <FormattedMessage id="make_an_offer" />
                    </Button>
                </ShouldLogInContainer>
                <ItemSaveContainer button className={styles.saveButton} itemId={itemId} showSavedCount />
            </div>
        </div>
    );
};

export default React.memo<Props>(BuyNowComponent);
